import { Component, Input, ViewChild, inject } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MenuService } from '../../menu.service';
import { SettingsService } from '../../../shared/settings/settings.service';
import { WebdokuService } from '../../../web-doku/webdoku.service';
import { BookmarkService } from '../../../bookmarks/bookmark.service';
import { InfoService } from '../../../shared/services/info.service';
import { NavigationBaseComponent } from '../navigation-base/navigation-base.component';
import { HttpLoadingService } from '../../http-loading.service';
import { UserInformationService } from '../../user-information.service';
import { LdwRouterService } from '../../../route/ldw-router.service';

@Component({
    selector: 'ldw-sidebar-navigation',
    templateUrl: './sidebar-navigation.component.html',
    styleUrls: ['./sidebar-navigation.component.css'],
    standalone: false
})
export class SidebarNavigationComponent extends NavigationBaseComponent {
  menuService: MenuService;
  webDokuService: WebdokuService;
  bookmarkService: BookmarkService;
  infoService: InfoService;
  httpLoadingService: HttpLoadingService;
  settingsService: SettingsService;
  userInformationService: UserInformationService;
  private routerService = inject(LdwRouterService);

  @ViewChild('sidenav') sidenav!: MatSidenav;
  @Input() title = '';


  constructor() {
    const menuService = inject(MenuService);
    const webDokuService = inject(WebdokuService);
    const bookmarkService = inject(BookmarkService);
    const infoService = inject(InfoService);
    const httpLoadingService = inject(HttpLoadingService);
    const settingsService = inject(SettingsService);
    const userInformationService = inject(UserInformationService);

    super(
      menuService,
      webDokuService,
      bookmarkService,
      infoService,
      httpLoadingService,
      settingsService,
      userInformationService
    );

    this.menuService = menuService;
    this.webDokuService = webDokuService;
    this.bookmarkService = bookmarkService;
    this.infoService = infoService;
    this.httpLoadingService = httpLoadingService;
    this.settingsService = settingsService;
    this.userInformationService = userInformationService;
  }
  showToolTip(): boolean {
    return this.settingsService.settings.viewMode.showTooltips;
  }

  closeBackdrop(force: boolean) {
    if (this.hasBackdrop || force) {
      this.sidenav.close();
    }
  }

  public get hasBackdrop(): boolean {
    return this.settingsService.settings.viewMode.sideBarCollapse;
  }

  navigateBack() {
    this.routerService.navigateBack();
  }
}
